import React from 'react';

import { logout } from '@/features/login/slice';
import { selectUser } from '@/features/user/selectors';
import { useAppDispatch } from '@/hooks';

import { Action } from '@bypasslane/clover--web-lib-sprout-action';
import { isNil } from 'ramda';
import { useSelector } from 'react-redux';

export const LogoutButton = () => {
  const dispatch = useAppDispatch();
  const user = useSelector(selectUser);

  const handleLogout = async () => {
    dispatch(logout());
  };

  if (isNil(user?.session_token)) {
    return null;
  }

  return (
    <Action variant="flat" onClick={handleLogout}>
      <p>Sign out</p>
    </Action>
  );
};

export default LogoutButton;
